import { useMemo, useState } from "react";
import { dynamics } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

const filters = ["全部", "预告", "回放", "合集", "记录", "栏目"];

const tagStyle = (tag: string) => {
  switch (tag) {
    case "预告":
      return "bg-primary-100 text-primary-800";
    case "回放":
      return "bg-accent-100 text-accent-800";
    case "合集":
      return "bg-secondary-200 text-secondary-900";
    case "记录":
      return "bg-background-300 text-foreground-800";
    default:
      return "bg-secondary-100 text-secondary-900";
  }
};

export default function DynamicsSection() {
  const [filter, setFilter] = useState("全部");

  const list = useMemo(
    () => (filter === "全部" ? dynamics : dynamics.filter((d) => d.tag === filter)),
    [filter],
  );

  return (
    <section id="dynamics" className="py-16 md:py-24">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <SectionHeading
          eyebrow="Updates"
          title="主播动态与开播预告"
          desc="主播的开播预告、回放上线、合集更新与栏目调整都会在这里同步，按时间倒序排列，跟着看就不会错过新作品。"
        />

        <div className="mb-8 flex flex-wrap gap-2" data-reveal>
          {filters.map((item) => {
            const active = item === filter;
            return (
              <button
                key={item}
                type="button"
                onClick={() => setFilter(item)}
                aria-pressed={active}
                className={`rounded-full px-3.5 py-1.5 text-xs md:text-sm transition-colors cursor-pointer whitespace-nowrap ${
                  active
                    ? "bg-primary-500 text-background-50"
                    : "bg-secondary-100 text-secondary-900 hover:bg-secondary-200"
                }`}
              >
                {item}
              </button>
            );
          })}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <ol className="lg:col-span-8 relative border-l border-background-300 pl-6 md:pl-8 space-y-7">
            {list.map((item) => (
              <li key={item.id} className="relative" data-reveal>
                <span className="absolute -left-[31px] md:-left-[39px] top-1.5 w-3.5 h-3.5 rounded-full border-2 border-background-50 bg-accent-500" />
                <div className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
                  <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                    <span className="font-num">{item.date}</span>
                    <span>{item.time}</span>
                    <span className={`rounded-full px-2.5 py-0.5 font-medium ${tagStyle(item.tag)}`}>
                      {item.type}
                    </span>
                  </div>
                  <p className="mt-2.5 text-sm md:text-base font-semibold text-foreground-950">
                    {item.streamer}
                  </p>
                  <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">
                    {item.content}
                  </p>
                </div>
              </li>
            ))}
          </ol>

          <aside className="lg:col-span-4" data-reveal>
            <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              <h3 className="text-sm md:text-base font-semibold text-foreground-950">
                本周上线概览
              </h3>
              <ul className="mt-4 space-y-4">
                {[
                  { label: "新增回放", value: "146", icon: "ri-history-line" },
                  { label: "合集更新", value: "12", icon: "ri-stack-line" },
                  { label: "开播预告", value: "38", icon: "ri-calendar-event-line" },
                  { label: "栏目调整", value: "5", icon: "ri-settings-3-line" },
                ].map((row) => (
                  <li key={row.label} className="flex items-center justify-between">
                    <span className="flex items-center gap-2 text-xs md:text-sm text-foreground-600">
                      <span className="w-8 h-8 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                        <i className={row.icon} />
                      </span>
                      {row.label}
                    </span>
                    <span className="font-num text-base font-bold text-primary-600">
                      {row.value}
                    </span>
                  </li>
                ))}
              </ul>
              <p className="mt-5 border-t border-background-200 pt-4 text-xs leading-relaxed text-foreground-500">
                以上为本周累计数据，统计口径与榜单一致，仅作内容更新参考。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}